import { lang } from '@3pc/cookiebanner';

const cookiebannerTemplateMinimal = (
  labels,
  consentTypes,
  consentButtonTypes,
  showTemplateMinimalInfoPanel,
  showTemplateConfigPanelOnRender,
  imprintLink,
  privacyPolicyLink,
  status
) => `<div class="cookiebanner cookiebanner--minimal" aria-modal="true" aria-labelledby="cookiebanner__label-main-panel" role="dialog" tabindex="0">
  <div class="cookiebanner__inner">
    <div class="cookiebanner__main-panel">
      <span id="cookiebanner__label-main-panel" class="cookiebanner__heading">${
        labels.mainPanelTitle[lang]
      }</span>
      ${labels.mainPanelText[lang] ? `${labels.mainPanelText[lang]}` : ''}
        ${
          status && status === 'deny'
            ? `<p class="cookiebanner__status"><strong>${labels.status[lang]} ${labels.statusRequiredAccepted[lang]}</strong></p>`
            : status && status === 'acceptTracking'
            ? `<p class="cookiebanner__status"><strong>${labels.status[lang]} ${labels.statusTrackingAccepted[lang]}</strong></p>`
            : status && status === 'acceptAll'
            ? `<p class="cookiebanner__status"><strong>${labels.status[lang]} ${labels.statusAllAccepted[lang]}</strong></p>`
            : ''
        }
      <div class="cookiebanner__buttons">
        <button data-consent="deny">
          <span>
            ${labels.acceptRequired[lang]}
          </span>
        </button>
        ${
          consentButtonTypes === 'required-tracking'
            ? ` <button data-consent="acceptTracking">
              <span>
                ${labels.acceptTracking[lang]}
              </span>
            </button>`
            : ''
        }
        ${
          consentButtonTypes === 'required-all'
            ? ` <button data-consent="acceptAll">
              <span>
                ${labels.acceptAll[lang]}
              </span>
            </button>`
            : ''
        }
      </div>
      ${
        showTemplateMinimalInfoPanel
          ? `
      <div class="cookiebanner__info-panel">
          <ul class="cookiebanner__list">
        ${consentTypes
          .map((consentType, index) =>
            consentType.showInInfoPanel
              ? `<li class="cookiebanner__list-item">
                <button class="cookiebanner__shower-button" aria-expanded="false">
                    <span>${consentType.name[lang]}</span>
                    <svg  aria-hidden="true" viewBox="0 0 40 23" preserveAspectRatio="xMidYMid meet">
                      <polygon points="36.9,0.5 20.3,17.1 19.6,17.1 3,0.5 0.6,3.1 20,22.4 39.4,3.1 "/>
                    </svg>
                  </button>
                <div class="cookiebanner__shower-panel">
                    <div class="cookiebanner__shower-panel-inner">
                        ${consentType.text[lang]}
                    </div>
                </div>
            </li>`
              : ''
          )
          .join('')}
            </ul>
        </div>
             ${
               imprintLink || privacyPolicyLink
                 ? `
                <div class="cookiebanner__links">
                    ${
                      privacyPolicyLink
                        ? `<a href=${privacyPolicyLink.url} target=${privacyPolicyLink.target}">${privacyPolicyLink.label}</a>`
                        : ''
                    }
                    ${
                      imprintLink
                        ? `<a href=${imprintLink.url} target=${imprintLink.target}>${imprintLink.label}</a>`
                        : ''
                    }
                </div>
                `
                 : ''
             }
      `
          : ''
      }
    </div>
  </div>
</div>`;

export { cookiebannerTemplateMinimal };
